module.exports = __webpack_public_path__ + "media/images/application/template/roofcare-ambient-poster-image-87605f5a7cb27327366340dcd851393a.jpg";